import React from 'react';
import { BookOpenIcon, SearchIcon, BookmarkIcon, GraduationCapIcon, StarIcon, ArrowRightIcon, BookIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
const VOCABULARY_CATEGORIES = [{
  title: {
    en: 'Common Phrases',
    ar: 'العبارات الشائعة'
  },
  count: 150,
  icon: StarIcon,
  examples: [{
    en: 'Nice to meet you',
    ar: 'تشرفت بمقابلتك'
  }, {
    en: 'How are you?',
    ar: 'كيف حالك؟'
  }]
}, {
  title: {
    en: 'Business English',
    ar: 'الإنجليزية للأعمال'
  },
  count: 120,
  icon: BookmarkIcon,
  examples: [{
    en: 'Meeting',
    ar: 'اجتماع'
  }, {
    en: 'Deadline',
    ar: 'موعد نهائي'
  }]
}, {
  title: {
    en: 'Academic Words',
    ar: 'الكلمات الأكاديمية'
  },
  count: 200,
  icon: GraduationCapIcon,
  examples: [{
    en: 'Research',
    ar: 'بحث'
  }, {
    en: 'Analysis',
    ar: 'تحليل'
  }]
}];
const GRAMMAR_TOPICS = [{
  title: {
    en: 'Present Tense',
    ar: 'زمن المضارع'
  },
  description: {
    en: 'Learn how to talk about habits and current actions',
    ar: 'تعلم كيفية التحدث عن العادات والأفعال الحالية'
  }
}, {
  title: {
    en: 'Past Tense',
    ar: 'زمن الماضي'
  },
  description: {
    en: 'Express completed actions and past experiences',
    ar: 'التعبير عن الأفعال المكتملة والتجارب الماضية'
  }
}, {
  title: {
    en: 'Future Tense',
    ar: 'زمن المستقبل'
  },
  description: {
    en: 'Discuss plans and make predictions',
    ar: 'مناقشة الخطط وتقديم التنبؤات'
  }
}];
export function ResourcesSection() {
  const {
    isArabic
  } = useLanguage();
  return <section className="w-full px-4 sm:px-6 md:px-10 lg:px-20 py-10 sm:py-12 md:py-16 bg-gray-50 dark:bg-gray-900/50" data-id="element-1307">
      <div className="max-w-7xl mx-auto" data-id="element-1308">
        {/* Search Bar */}
        <div className="relative max-w-2xl mx-auto mb-8 sm:mb-12 px-2 sm:px-0" data-id="element-1309">
          <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-gray-500" data-id="element-1310" />
          <input type="text" placeholder={isArabic ? 'ابحث عن الكلمات والقواعد...' : 'Search words and grammar...'} className="w-full pl-12 pr-4 py-3 rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent transition-all duration-200" dir={isArabic ? 'rtl' : 'ltr'} data-id="element-1311" />
        </div>
        {/* Vocabulary Section */}
        <div className="mb-10 sm:mb-16 px-2 sm:px-0" data-id="element-1312">
          <div className="flex items-center justify-between mb-6 sm:mb-8" data-id="element-1313">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white" data-id="element-1314">
              {isArabic ? 'قوائم المفردات' : 'Vocabulary Lists'}
            </h2>
            <Link to="/resources/vocabulary" className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 flex items-center gap-1 sm:gap-2 text-sm sm:text-base" data-id="element-1315">
              <span data-id="element-1316">{isArabic ? 'عرض الكل' : 'View All'}</span>
              <ArrowRightIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-1317" />
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-1318">
            {VOCABULARY_CATEGORIES.map((category, index) => {
            const Icon = category.icon;
            return <div key={index} className="bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-200" data-id="element-1319">
                  <div className="p-4 sm:p-6" data-id="element-1320">
                    <div className="flex items-center justify-between mb-3 sm:mb-4" data-id="element-1321">
                      <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600 dark:text-blue-400" data-id="element-1322" />
                      <span className="text-xs sm:text-sm text-gray-500 dark:text-gray-400" data-id="element-1323">
                        {category.count} {isArabic ? 'كلمة' : 'words'}
                      </span>
                    </div>
                    <h3 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white mb-3 sm:mb-4" data-id="element-1324">
                      {isArabic ? category.title.ar : category.title.en}
                    </h3>
                    <div className="space-y-2" data-id="element-1325">
                      {category.examples.map((example, i) => <div key={i} className="flex items-center justify-between p-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors" data-id="element-1326">
                          <span className="text-sm sm:text-base text-gray-900 dark:text-white" data-id="element-1327">
                            {example.en}
                          </span>
                          <span className="text-sm sm:text-base text-blue-600 dark:text-blue-400" dir="rtl" data-id="element-1328">
                            {example.ar}
                          </span>
                        </div>)}
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>
        {/* Grammar Section */}
        <div className="px-2 sm:px-0" data-id="element-1329">
          <div className="flex items-center justify-between mb-6 sm:mb-8" data-id="element-1330">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white" data-id="element-1331">
              {isArabic ? 'دليل القواعد' : 'Grammar Guide'}
            </h2>
            <Link to="/resources/grammar" className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 flex items-center gap-1 sm:gap-2 text-sm sm:text-base" data-id="element-1332">
              <span data-id="element-1333">{isArabic ? 'عرض الكل' : 'View All'}</span>
              <ArrowRightIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-1334" />
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-1335">
            {GRAMMAR_TOPICS.map((topic, index) => <div key={index} className="group bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-lg transition-all duration-200 p-4 sm:p-6" data-id="element-1336">
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white mb-1 sm:mb-2" data-id="element-1337">
                  {isArabic ? topic.title.ar : topic.title.en}
                </h3>
                <p className="text-sm sm:text-base text-gray-600 dark:text-gray-300 mb-3 sm:mb-4" data-id="element-1338">
                  {isArabic ? topic.description.ar : topic.description.en}
                </p>
                <Link to={`/resources/grammar`} className="text-sm sm:text-base text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 flex items-center gap-1 sm:gap-2 group-hover:translate-x-2 transition-transform duration-200" data-id="element-1339">
                  <span data-id="element-1340">{isArabic ? 'تعلم المزيد' : 'Learn More'}</span>
                  <ArrowRightIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-1341" />
                </Link>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}